import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // 全局 CSS
import App from './App';
// 統一使用 BrowserRouter 作為應用的路由模式
import { BrowserRouter as Router } from 'react-router-dom';
import i18n from 'i18next';
import { I18nextProvider } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import en from './i18n/en.json';
import zhTW from './i18n/zh-tw.json';

import reportWebVitals from './reportWebVitals';

// 初始化 i18n
i18n
  .use(Backend)
  .use(LanguageDetector)
  .init({
    resources: {
      en: { translation: en },
      'zh-TW': { translation: zhTW },
    },
    fallbackLng: 'en',
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false, // React 預設已防止 XSS 攻擊
    },
    debug: false, // 在生產環境中建議設為 false，開發時可設為 true 方便除錯
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* I18nextProvider 提供國際化上下文 */}
    <I18nextProvider i18n={i18n}>
      {/* BrowserRouter 包裹整個 App，確保路由功能正常 */}
      <Router>
        <App />
      </Router>
    </I18nextProvider>
  </React.StrictMode>
);

// 測量應用性能 (可選)
reportWebVitals();